import { IAccountApi } from "../api/IAccountApi";

interface MemberAvatarOptions {
  picUrl?: string; // Initial avatar URL
}

class MemberAvatar {
  private readonly element: HTMLElement;
  private avatar: string;
  private editMode: boolean;
  private icon: string;
  private uploading: boolean;
  private errorMessage: string;
  private fileInput: HTMLInputElement | null;
  private readonly options: MemberAvatarOptions;
  private readonly accountApi: IAccountApi;

  constructor(element: HTMLElement, accountApi: IAccountApi, options: MemberAvatarOptions = {}) {
    this.element = element;
    this.options = options;
    this.avatar = options.picUrl || "/images/no-profile.png"; // Default avatar
    this.editMode = false;
    this.icon = "/images/icons-sprite.svg#upload-32";
    this.uploading = false;
    this.errorMessage = "";
    this.fileInput = this.element.querySelector<HTMLInputElement>('input[type="file"]'); //Get the file input
    this.accountApi = accountApi;

    this.initialize();
  }

  private initialize(): void {
    this.render(); // Initial render
    this.setupEventListeners();
  }

  private render(): void {
      this.element.innerHTML = `
          <form class="account-image-upload account-image-action" ${this.editMode ? 'style="display: none;"' : ''} ng-submit="upload()">
              <input accept="image/*" type="file" name="fileupload" value="fileupload" id="fileupload">
              <label for="fileupload">
                  <div class="image-action-button" ${this.uploading ? 'style="display: none;"' : ''}>
                      <svg class="icon" viewBox="0 0 32 32">
                          <use xlink:href="${this.icon}"></use>
                      </svg>
                  </div>
              </label>
          </form>

          <div ${!this.uploading ? 'style="display: none;"' : ''} class="box__content" aria-hidden="true">
              <div class="text-center">
                  <img src="/images/loader.svg" alt="loading">
              </div>
          </div>
          <img ${this.uploading ? 'style="display: none;"' : ''} src="${this.avatar}" alt="" class="avatar avatar--xl">
      `;

      this.fileInput = this.element.querySelector<HTMLInputElement>('input[type="file"]');
  }

  private setupEventListeners(): void {
    if (!this.fileInput) {
        console.warn('File input not found.');
        return;
    }

    this.fileInput.addEventListener('change', () => {
      this.upload();
    });

  }

  private setEditMode(avatarUrl: string): void {
    this.avatar = avatarUrl;
    this.editMode = true;
    this.icon = "/images/icons-sprite.svg#pen-32";
    this.render();
  }

  private async upload(): Promise<void> {
    if (!this.fileInput || this.fileInput.files == null || this.fileInput.files.length === 0) {
        console.warn('No file selected.');
        this.errorMessage = "Please select an image.";
        return;
    }


    this.uploading = true;
    this.errorMessage = "";
    const file = this.fileInput.files[0];
    this.render();

    try {
      const response = await this.accountApi.uploadAvatar(file);
      this.uploading = false;
      this.setEditMode(response.data);
    } catch (error: any) {
      this.uploading = false;
      this.errorMessage = "Error uploading avatar.";
      console.error(error);
    } finally {
        this.render();
    }
  }
}

export default MemberAvatar;